
import { logger } from "./logger";

export const setupClickLogger = (user) => {
  const username = user?.username || "";
  const role = user?.role || "";

  document.addEventListener("click", (e) => {
    // Only consider the closest button, link, submit input, or data-log element
    const target = e.target.closest("button, a, input[type='submit'], [data-log]");

    if (!target) return;

    // Prevent multiple logs if the click was inside a nested button/input
    if (target.dataset.logged) return;
    target.dataset.logged = true;
    setTimeout(() => delete target.dataset.logged, 50); // reset after short delay

    const buttonName =
      target.dataset.log ||
      target.innerText?.trim() ||
      target.getAttribute("aria-label") ||
      target.title ||
      "";

    // Skip icon-only buttons we can't identify — "Unknown Button" is noise
    if (!buttonName) return;

    logger.info(`${buttonName} clicked`, {
      page: document.title || "",
      buttonName,
      username,
      role,
    });
  });
};
